import type {NoopType} from '../type';

import {timersQueue} from './timersQueue';

export const setTimeoutQueue = timersQueue(setTimeout, clearTimeout);
const idleCallback =
    'requestIdleCallback' in globalThis
        ? timersQueue(cb => globalThis.requestIdleCallback(cb), globalThis.cancelIdleCallback)
        : null;

/**
 * setIdleCallbackQueue
 */
export const setIdleCallbackQueue = <T>(cb: NoopType<T>, ms: number) =>
    idleCallback ? idleCallback(cb, ms) : setTimeoutQueue(cb, ms);

/**
 * setAfterCommitQueue
 */
export const setAfterCommitQueue = <T>(cb: NoopType<T>) => {
    requestAnimationFrame(() => setTimeoutQueue(cb, 6));
};
